/**
 * Issue #346 — 管理端数据总览「KPI 考核」明细 API 客户端 + 类型（与 apps/api 契约对齐）。
 * GET /admin/kpi：day/week/month 粒度 + 关键词 / 部门 / 单员工 + 分页 + 排序 → { items, pagination, window }。
 */
import { apiClient } from './api';

export type KpiGranularity = 'day' | 'week' | 'month';
export type KpiSortBy =
  | 'totalPoints'
  | 'onlineDurationSec'
  | 'onlineTimePoints'
  | 'learningPoints'
  | 'qcPoints'
  | 'name';
export type SortOrder = 'asc' | 'desc';

export interface AdminKpiRow {
  employeeId: string;
  name: string;
  username: string | null;
  jobTitle: string | null;
  deptId: string | null;
  deptName: string | null;
  avatarUrl: string | null;
  onlineDurationSec: number;
  onlineTimePoints: number;
  learningPoints: number;
  qcPoints: number;
  totalPoints: number;
}

export interface AdminKpiWindow {
  granularity: KpiGranularity;
  start: string;
  end: string;
  label: string;
}

export interface AdminKpiListResult {
  items: AdminKpiRow[];
  pagination: { page: number; pageSize: number; total: number; totalPages: number };
  window: AdminKpiWindow;
}

export interface AdminKpiQuery {
  granularity: KpiGranularity;
  date?: string;
  keyword?: string;
  deptId?: string;
  employeeId?: string;
  page: number;
  pageSize: number;
  sortBy: KpiSortBy;
  sortOrder: SortOrder;
}

export async function listAdminKpiApi(
  query: AdminKpiQuery,
): Promise<AdminKpiListResult> {
  return apiClient.get<AdminKpiListResult>(
    '/admin/kpi',
    query as unknown as Record<string, unknown>,
  );
}
